import { createConsts, createActions } from '../../utils/redux';

export const consts = createConsts('ui', 'default-tab', 'SET_TAB', 'RESET');
export const actions = createActions(consts);

const initialState = {
  id: null,
};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.SET_TAB:
      return {
        ...state,
        id: payload,
      };
    case consts.RESET:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/defaultTab.js